import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import CategorySelect from "../forms/CategorySelect";

export default function ModalEditN4({ data, onSave, onCancel }) {
    const [form, setForm] = useState({});

    useEffect(() => {
        if (data) {
            setForm(data);
        }
    }, [data]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(form);
    };

    return (
        <Form onSubmit={handleSubmit} className="font-monospace">
            <Row>
                <Col md={12} className="mb-3">
                    <Form.Group>
                        <Form.Label>marker_name</Form.Label>
                        <Form.Control type="text" name="marker_name" value={form.marker_name || ''} onChange={handleChange} />
                    </Form.Group>
                </Col>

                <Col md={6} className="mb-3">
                    <Form.Group>
                        <Form.Label>chromosome</Form.Label>
                        <Form.Control type="text" name="chromosome" value={form.chromosome || ''} onChange={handleChange} />
                    </Form.Group>
                </Col>
                <Col md={6} className="mb-3">
                    <Form.Group>
                        <Form.Label>position</Form.Label>
                        <Form.Control type="text" name="position" value={form.position || ''} onChange={handleChange} />
                    </Form.Group>
                </Col>

                <Col md={6} className="mb-3">
                    <Form.Group>
                        <Form.Label>start</Form.Label>
                        <Form.Control type="text" name="start" value={form.start || ''} onChange={handleChange} />
                    </Form.Group>
                </Col>
                <Col md={6} className="mb-3">
                    <Form.Group>
                        <Form.Label>end</Form.Label>
                        <Form.Control type="text" name="end" value={form.end || ''} onChange={handleChange} />
                    </Form.Group>
                </Col>

                <Col md={6} className="mb-3">
                    <Form.Group>
                        <Form.Label>favourable_allele</Form.Label>
                        <Form.Control type="text" name="favourable_allele" value={form.favourable_allele || ''} onChange={handleChange} />
                    </Form.Group>
                </Col>
                <Col md={6} className="mb-3">
                    <Form.Group>
                        <Form.Label>unfavourable_allele</Form.Label>
                        <Form.Control type="text" name="unfavourable_allele" value={form.unfavourable_allele || ''} onChange={handleChange} />
                    </Form.Group>
                </Col>

                <Col md={6} className="mb-3">
                    <Form.Group>
                        <Form.Label>target_qtl</Form.Label>
                        <Form.Control type="text" name="target_qtl" value={form.target_qtl || ''} onChange={handleChange} />
                    </Form.Group>
                </Col>
                <Col md={6} className="mb-3">
                    <Form.Group>
                        <Form.Label>trait_category</Form.Label>
                        <Form.Control type="text" name="trait_category" value={form.trait_category || ''} onChange={handleChange} />
                    </Form.Group>
                </Col>

                <Col md={6} className="mb-3">
                    <Form.Group>
                        <Form.Label>marker_type</Form.Label>
                        <Form.Control type="text" name="marker_type" value={form.marker_type || ''} onChange={handleChange} />
                    </Form.Group>
                </Col>
                <Col md={6} className="mb-3">
                    <Form.Group>
                        <Form.Label>marker_linkage</Form.Label>
                        <Form.Control type="text" name="marker_linkage" value={form.marker_linkage || ''} onChange={handleChange} />
                    </Form.Group>
                </Col>

                <Col md={12} className="mb-3">
                    <Form.Group>
                        <Form.Label>sequence</Form.Label>
                        <Form.Control type="text" name="sequence" value={form.sequence || ''} onChange={handleChange} />
                    </Form.Group>
                </Col>

                <Col md={6} className="mb-3">
                    <Form.Group>
                        <Form.Label>finger_printing</Form.Label>
                        <Form.Control type="text" name="finger_printing" value={form.finger_printing || ''} onChange={handleChange} />
                    </Form.Group>
                </Col>
                <Col md={6} className="mb-3">
                    <Form.Group>
                        <Form.Label>specificity</Form.Label>
                        <Form.Control type="text" name="specificity" value={form.specificity || ''} onChange={handleChange} />
                    </Form.Group>
                </Col>
                <Col md={12} className="mb-3">
                    <Form.Group>
                        <Form.Label>source</Form.Label>
                        <Form.Control type="text" name="source" value={form.source || ''} onChange={handleChange} />
                    </Form.Group>
                </Col>
                <Col md={6} className="mb-3">
                    <Form.Group>
                        <Form.Label>rice_cultivar_th</Form.Label>
                        <Form.Control type="text" name="rice_cultivar_th" value={form.rice_cultivar_th || ''} onChange={handleChange} />
                    </Form.Group>
                </Col>
                <Col md={6} className="mb-3">
                    <Form.Group>
                        <Form.Label>rice_cultivar_en</Form.Label>
                        <Form.Control type="text" name="rice_cultivar_en" value={form.rice_cultivar_en || ''} onChange={handleChange} />
                    </Form.Group>
                </Col>

                <Col md={12} className="mb-3">
                    <Form.Group>
                        <Form.Label>gs_no</Form.Label>
                        <Form.Control type="text" name="gs_no" value={form.gs_no || ''} onChange={handleChange} />
                    </Form.Group>
                </Col>

                <Col md={12} className="mb-3">
                    <Form.Group>
                        <Form.Label>หมวดหมู่ (Category)</Form.Label>
                        <CategorySelect hideOptionAll value={form.category_id || ''} onChange={handleChange} name="category_id" />
                    </Form.Group>
                </Col>
            </Row>

            <div className="d-flex justify-content-end gap-2 mt-3">
                <Button variant="light" onClick={onCancel}>ยกเลิก</Button>
                <Button variant="primary" type="submit">บันทึก</Button>
            </div>
        </Form>
    );
}
